var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoodColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.72 147.44C114.434 147.44 147.44 114.434 147.44 73.72C147.44 33.0056 114.434 0 73.72 0C33.0056 0 0 33.0056 0 73.72C0 114.434 33.0056 147.44 73.72 147.44Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0649 96.7416C43.2492 97.4747 47.8485 114.676 73.7201 114.676C99.5958 114.676 104.191 97.4747 104.375 96.7416C104.601 95.8528 104.199 94.9313 103.405 94.4726C102.606 94.018 101.607 94.1532 100.947 94.788C100.87 94.8658 92.9446 102.389 73.7201 102.389C54.4955 102.389 46.5666 94.8658 46.4928 94.7921C46.0997 94.403 45.5754 94.1982 45.0512 94.1982C44.7072 94.1982 44.359 94.2842 44.0437 94.4604C43.241 94.9191 42.8396 95.8488 43.0649 96.7416Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1467 69.6249C54.8014 69.6249 59.3856 63.2072 59.3856 55.2905C59.3856 47.3738 54.8014 40.9561 49.1467 40.9561C43.4919 40.9561 38.9078 47.3738 38.9078 55.2905C38.9078 63.2072 43.4919 69.6249 49.1467 69.6249Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2933 69.6249C103.948 69.6249 108.532 63.2072 108.532 55.2905C108.532 47.3738 103.948 40.9561 98.2933 40.9561C92.6385 40.9561 88.0544 47.3738 88.0544 55.2905C88.0544 63.2072 92.6385 69.6249 98.2933 69.6249Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodColor);
export default __webpack_public_path__ + "static/media/goodColor.db8f82db4e4992575974eb3c8028d57e.svg";
export { ForwardRef as ReactComponent };